import React from 'react';
import BzitCountUsageImage from '../../bzit/BzitCountUsageImage';
import { Column } from '../../components/Grid';
import {
  BustypeRow,
  Description,
  DescriptionColumn,
  DescriptionName,
  DescriptionUsage
} from '../../components/Stage';
import Typo3Label from '../../provider/Typo3Provider/Typo3Label';
import { Maybe } from '../../types';

interface BustypeCountAllProps {
  usages: { [key: string]: Maybe<number> };
  clickShowSearchResult: () => void;
}

const BustypeCountAll = ({
  usages,
  clickShowSearchResult
}: BustypeCountAllProps) => {
  // we require the values of `usages` have the Type `Maybe<numbher>`
  // so if we get all values and filter them by `Boolean` we end up
  // with an array full of numbers
  // `0` would be filtered out as well, but as we want to sum all
  // numbers, zeroes don't matter at all
  const values: number[] = Object.values(usages).filter(Boolean) as any[];
  const allUsages: number = values.reduce((prev, curr = 0) => prev + curr, 0);

  return (
    <Column medium={6} small={12}>
      <BustypeRow noGap bg="white" onClick={clickShowSearchResult}>
        <Column small={6}>
          <BzitCountUsageImage type="ALL" />
        </Column>
        <DescriptionColumn small={6}>
          <Description>
            <DescriptionUsage>{allUsages}</DescriptionUsage>
            <DescriptionName>
              <Typo3Label label="busSelect.allBusses" />
            </DescriptionName>
          </Description>
        </DescriptionColumn>
      </BustypeRow>
    </Column>
  );
};

export default BustypeCountAll;
